<footer role="contentinfo" class="footer">
  <div class="grid-container grid-container--site-width">
    <div class="grid-row footer__inner">
        <div class="grid-column footer__content footer__content--left">
          © {{anio}} {{'app.footer-copyright' | translate}}
        </div>
        <div class="grid-column footer__content footer__content--right">    
          <a class="link" target="_blank" href="https://www.aramark.es/">{{'app.footer-legend' | translate}}</a>
          <span>{{'labels.version' | translate }} {{version}}</span>
        </div>
    </div>
  </div>
</footer>
